import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import { Empty } from 'src/components/Ant'

import { Footer, OptionsBar, TitleReport } from '..'
import { TableDetail } from './components'
import * as CSSPage from '../../styles'
import * as CSS from './styles'
import { SectionHeader } from '../r-10/components'

const MaxRecordsFirstPage = 41
const MaxRecords = 44

export default function R10() {
  const {
    reports: {
      reportsResources: {
        R10Data: { data }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length) {
      return [
        [
          <TitleReport title="web.report.10.title" />,
          <SectionHeader />,
          <Empty />
        ]
      ]
    }

    const tempPages: JSX.Element[][] = []

    let index = 0
    let pageNumber = 0

    // Make pages //
    do {
      const page: JSX.Element[] = []
      let slices = 1
      page.push(<TitleReport title="web.report.10.title" />)

      if (!pageNumber) {
        page.push(<SectionHeader />)
        slices = MaxRecordsFirstPage
      } else {
        slices = MaxRecords
      }

      const records = data.slice(index, index + slices)
      page.push(
        <CSS.WrapTableDiv>
          <TableDetail dataSource={records} />
        </CSS.WrapTableDiv>
      )

      index += slices
      pageNumber += 1
      tempPages.push(page)
    } while (index < data.length)
    return tempPages
  }, [data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <CSSPage.WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <CSSPage.WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </CSSPage.WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </CSSPage.WrapPage>
      ))}
    </>
  )
}
